import { BootLogoLoader } from '@/components/ap/logos/BootLogoLoader';
import { resolveExperienceShellSkeleton } from '@/components/ap/skeletons';
import { OnlineStatusContextProvider } from '@/contexts/onlineStatus';
import { useCleanAuthQueryParams } from '@/hooks/useCleanAuthQueryParams';
import { selectIsMacAppLoginActive } from '@/store/authStore';
import { Authenticated } from '@refinedev/core';
import { CatchAllNavigate, NavigateToResource } from '@refinedev/react-router';
import { Outlet, useLocation } from 'react-router';

/** First-load loader (supersedes R2-G62's generic branch): while the boot auth
 *  check runs, show v3's pulsating "A" (BootLogoLoader) — same look as the
 *  index.html #main-loading-spinner it takes over from, so the reload sequence
 *  reads as one continuous loader. Experience deep routes KEEP their
 *  full-screen shell skeletons (exam surfaces, deliberately shell-shaped). */
const AuthPendingFallback = () => {
  const { pathname } = useLocation();
  const shellSkeleton = resolveExperienceShellSkeleton(pathname);
  if (shellSkeleton) return <>{shellSkeleton}</>;
  return <BootLogoLoader />;
};

const CustomAuthenticated = (props: any) => {
  // Clean auth query params after authentication check completes
  useCleanAuthQueryParams();
  return (
    <Authenticated
      loading={<AuthPendingFallback />}
      fallback={<CatchAllNavigate to="/auth/login" />}
      {...props}
    >
      <OnlineStatusContextProvider>{props.children}</OnlineStatusContextProvider>
    </Authenticated>
  );
};

// The Mac-app sign-in window shares Safari's session: show the login form, not the home page.
export const NavigateToResourceUnlessMacAppLogin = () =>
  selectIsMacAppLoginActive() ? <Outlet /> : <NavigateToResource />;

export default CustomAuthenticated;
